export default function BrandHero() {
  return (
    <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=modern%20creative%20media%20brand%20hero%20visual%2C%20abstract%20orange%20red%20and%20peach%20gradient%20shapes%20flowing%2C%20soft%20green%20accents%2C%20minimal%20geometric%20artistic%20composition%20on%20cream%20background%2C%20cinematic%20editorial%20style%2C%20high%20detail&width=1920&height=1080&seq=xmt-brand-hero&orientation=landscape"
        alt="小蜜桃品牌服务 - 让好内容被更多人看见"
        title="小蜜桃品牌服务"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/50 to-foreground-950/35"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3">
              <span className="w-12 h-12 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-2xl">
                <i className="ri-plant-line"></i>
              </span>
              <span className="font-brand text-3xl text-background-50">小蜜桃</span>
            </div>
            <p className="mt-4 text-sm md:text-base text-background-100/90 tracking-[0.2em]">
              让好内容，被更多人温柔地看见
            </p>
            <h1 className="mt-3 font-heading font-bold text-3xl md:text-5xl text-background-50 leading-tight">
              多元娱乐资讯与品牌服务平台
            </h1>
            <p className="mt-4 text-sm md:text-base text-background-100/85 max-w-xl leading-relaxed">
              从内容策划到品牌传播，小蜜桃用真实、亲切的方式，
              帮品牌与创作者把值得被看见的故事讲出来。
            </p>
            <a
              href="#contact-form"
              className="mt-7 inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm px-6 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-chat-3-line"></i>
              发起合作咨询
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}